import { translateBlockValue } from 'i18n';
import { BudgetSections } from 'business/constants';
import { TFunction } from 'i18next';

export const getSectionLabel = (
    section: BudgetSections | null,
    t: TFunction,
) =>
    section
        ? t('projection.invFunc', {
              invFunc: translateBlockValue(section),
          })
        : t('projection.titleAlt');
